import { IDict } from "./types";

export const es: IDict = {
  Jobs: "Trabajos",
  "No Jobs": "Sin Trabajos",
  Billing: "Facturación",
  Credits: "Créditos",
  "Pay Per Use": "Pagar por Uso",
  "Feature Voting": "Votación de Funciones",
  "Free Karaoke Left": "Karaoke Gratis Restante",
  "Upgrade Now to Create More": "Actualiza Ahora para Crear Más",
  "Storage is Full": "El almacenamiento está lleno",
  "Youka is running out of storage space":
    "Youka se está quedando sin espacio de almacenamiento",
  "Please free up at least 1 GB before creating new karaoke":
    "Por favor, libera al menos 1 GB antes de crear un nuevo karaoke",
  "Click the button to check again":
    "Haz clic en el botón para verificar de nuevo",
  "No Internet Connection": "Sin conexión a Internet",
  "Youka cannot connect to the internet":
    "Youka no puede conectarse a internet",
  "Please make sure you have internet connection":
    "Por favor, asegúrate de tener conexión a internet",
  "Update is ready": "La actualización está lista",
  "Click the button to update": "Haz clic en el botón para actualizar",
  "Library Folder": "Carpeta de Biblioteca",
  "Export Folder": "Carpeta de Exportación",
  "Sync Model": "Modelo de Sincronización",
  "Max Video Quality": "Calidad Máxima de Vídeo",
  "Speed / Compression Preset": "Preajuste de Velocidad / Compresión",
  Change: "Cambiar",
  "dialogs.upgrade.upgrade_to_pro":
    "La función que estás buscando es parte del plan profesional; actualiza ahora para desbloquear esta función.",
  "dialogs.upgrade.upgrade_to_standard":
    "La función que estás buscando es parte del plan estándar; actualiza ahora para desbloquear esta función.",
  heads_up: "¡Atención!",
  "dialogs.edit_lyrics.not_supported":
    "El idioma que has elegido actualmente no es compatible con la sincronización automática de letras. Sin embargo, puedes guardar tu progreso y luego utilizar el Editor de nivel de línea para sincronizar las letras manualmente.",
  "dialogs.create.title": "Crear nuevo karaoke",
  "dialogs.create.description":
    "Por favor, completa el formulario a continuación para crear un nuevo karaoke, puedes usar un archivo de audio o video, las letras son opcionales.",
  "dialogs.edit_lyrics.description":
    "Después de guardar, se iniciará el proceso de sincronización; puedes seguir el progreso en la pestaña Trabajos",
  "dialogs.upgrade.see_plans": "Ver Planes",
  "dialogs.upgrade.unlock": "Desbloquear",
  "comps.sync_editor.attach_previous": "Adjuntar a la palabra anterior",
  "comps.sync_editor.attach_next": "Adjuntar a la próxima palabra",
  "comps.plans.title":
    "Elige el plan que mejor se ajuste a tus necesidades. Siempre puedes mejorar o disminuir tu plan",
  "Font Size": "Tamaño de Fuente",
  Spacing: "Espaciado",
  Outline: "Contorno",
  "Margin Bottom": "Margen Inferior",
  "Max Chars per Line": "Máx Caract. por Línea",
  Bold: "Negrita",
  Italic: "Cursiva",
  Shadow: "Sombra",
  month: "mes",
  songs: "canciones",
  Title: "Título",
  "Save and Sync": "Guardar y Sincronizar",
  Lyrics: "Letras",
  Update: "Actualizar",
  Playlist: "Lista de Reproducción",
  Canceling: "Cancelando",
  Play: "Reproducir",
  "Lyrics Language": "Idioma de las Letras",
  "Background Image": "Imagen de Fondo",
  "Basic Version": "Versión Básica",
  "Standard Version": "Versión Estándar",
  "Pro Version": "Versión Pro",
  "Trial Version": "Versión de Prueba",
  "No Active Plan": "Sin Plan Activo",
  "Days Left in Trial": "Días Restantes en la Prueba",
  Paste: "Pegar",
  "Sync Lyrics": "Sincronizar Letras",
  Show: "Mostrar",
  Settings: "Configuración",
  Retry: "Reintentar",
  "Create Karaoke": "Crear Karaoke",
  Canceled: "Cancelado",
  Reset: "Reiniciar",
  "Edit Video": "Editar Video",
  Download: "Descargar",
  "Edit Metadata": "Editar Metadatos",
  "Subtitle Designer": "Diseñador de Subtítulos",
  Export: "Exportar",
  year: "año",
  Basic: "Básico",
  Standard: "Estándar",
  Pro: "Pro",
  Accept: "Aceptar",
  "Add new word": "Agregar nueva palabra",
  "Add to queue": "Añadir a la cola",
  "An unknown error occurred": "Ocurrió un error desconocido",
  Annually: "Anualmente",
  "Are you sure you want to delete this karaoke song?":
    "¿Estás seguro de que quieres eliminar esta canción de karaoke?",
  "Artist Name": "Nombre del Artista",
  "Audio or Video File": "Archivo de Audio o Video",
  Audio: "Audio",
  "Auto Karaoke Generator": "Generador Automático de Karaoke",
  "Auto Lyrics Sync": "Sincronización Automática de Letras",
  "Cancel Plan": "Cancelar Plan",
  Cancel: "Cancelar",
  Close: "Cerrar",
  "Create Karaoke from song": "Crear Karaoke desde la Canción",
  "Create Karaoke from local files": "Crear Karaoke desde archivos locales",
  "Create new karaoke": "Crear nuevo karaoke",
  Create: "Crear",
  "Current Plan": "Plan Actual",
  "Dark Mode": "Modo Oscuro",
  Decline: "Rechazar",
  "Delete word": "Eliminar palabra",
  Delete: "Eliminar",
  "Edit Lyrics": "Editar Letras",
  Edit: "Editar",
  "Export to mp3/mp4": "Exportar a mp3/mp4",
  "Go Back to EULA": "Regresar al EULA",
  "Go back": "Regresar",
  "Go forward": "Avanzar",
  Home: "Inicio",
  "I accept the terms and commit to avoiding unlicensed use of copyrighted content":
    "Acepto los términos y me comprometo a evitar el uso no autorizado de contenido con derechos de autor",
  Instruments: "Instrumentos",
  Key: "Tonalidad",
  Library: "Biblioteca",
  "Light Mode": "Modo Claro",
  "Line Level Sync": "Sincronización a Nivel de Línea",
  "Line Level": "Nivel de Línea",
  "Lyrics (optional)": "Letras (opcional)",
  "Lyrics Sync Editor": "Editor de Sincronización de Letras",
  Manage: "Gestionar",
  Monthly: "Mensual",
  "Most popular": "Más popular",
  "No new notifications": "No hay nuevas notificaciones",
  "No results": "Sin resultados",
  "No songs in library": "No hay canciones en la biblioteca",
  "No songs in queue": "No hay canciones en la cola",
  Notifications: "Notificaciones",
  Off: "Apagado",
  Or: "O",
  "Plan canceled, will end in": "Plan cancelado, terminará en",
  "Play word in loop": "Reproducir palabra en bucle",
  "Preparing Youka": "Preparando Youka",
  "Process 2 karaokes at a time": "Procesar 2 karaokes a la vez",
  "Process 5 karaokes at a time": "Procesar 5 karaokes a la vez",
  Queue: "Cola",
  Ready: "Listo",
  "Remove from queue": "Eliminar de la cola",
  "Resume plan": "Reanudar plan",
  "Save and Resync": "Guardar y Resincronizar",
  Save: "Guardar",
  "Saving...": "Guardando...",
  Search: "Buscar",
  "Select plan": "Seleccionar plan",
  "Sign In": "Iniciar Sesión",
  "Sign Out": "Cerrar Sesión",
  "Sign Up": "Registrarse",
  "Song Name": "Nombre de la Canción",
  "Start typing to search or paste YouTube URL":
    "Empieza a escribir para buscar o pega la URL de YouTube",
  "Start typing to search": "Empieza a escribir para buscar",
  "Subtitle Track": "Pista de Subtítulos",
  Subtitles: "Subtítulos",
  Tempo: "Tempo",
  "Terms and Conditions": "Términos y Condiciones",
  "This action cannot be undone.": "Esta acción no se puede deshacer.",
  "Thumbnail URL": "URL de Miniatura",
  "To keep the karaoke fun going, please upgrade":
    "Para continuar con la diversión del karaoke, por favor actualiza",
  "Unlock Premium Features with an Upgrade!":
    "¡Desbloquea Funciones Premium con una Actualización!",
  "Update Payment Method": "Actualizar Método de Pago",
  "Upgrade to Pro plan to enable": "Actualiza al plan Pro para habilitar",
  Upgrade: "Actualizar",
  Version: "Versión",
  Video: "Video",
  Vocals: "Vocales",
  "Waiting in queue": "Esperando en cola",
  "Word Level Sync": "Sincronización a Nivel de Palabra",
  "Word Level": "Nivel de Palabra",
  "You need to accept the EULA to use Youka":
    "Necesitas aceptar el EULA para usar Youka",
  "Your lyrics have been saved successfully. A resync is currently in progress. You can monitor the progress in the notification area. Once the resync is complete, you'll be able to see the changes - just hit 'play'.":
    "Tus letras han sido guardadas exitosamente. Una resincronización está en curso. Puedes monitorear el progreso en el área de notificaciones. Una vez que la resincronización esté completa, podrás ver los cambios - solo presiona 'reproducir'.",
  "Your trial version of Youka has expired":
    "Tu versión de prueba de Youka ha expirado",
  "dialogs.youtube.title":
    "Instale el complemento yt-dlp para buscar y reproducir videos en línea",
  "dialogs.youtube.description":
    "Lea y acepte las siguientes advertencias antes de habilitar el complemento.",
  "dialogs.youtube.agree": "He leído y entendido las advertencias anteriores",
  "dialogs.youtube.install": "Instalar Plugin",
  "dialogs.youtube.install_success": "Plugin instalado con éxito",
  "dialogs.youtube.install_success_description":
    "Ahora puede buscar y reproducir videos en línea",
  "dialogs.youtube.install_error": "Error en la instalación del Plugin",
  "alert.youtube.description":
    "El Plugin de Búsqueda y Descarga de Videos en Línea (yt-dlp) no está preinstalado. Haz clic para instalar el plugin.",
  "alert.youtube.install": "Instalar Plugin",
  "dialogs.settings.enable_youtube": "Habilitar Plugin yt-dlp",
  "dialogs.youtube.warnings": [
    {
      title: "Cumplimiento Legal",
      description:
        "Asegúrate de que el uso de este plugin cumpla completamente con todas las leyes aplicables y los términos de servicio de cualquier plataforma con la que interactúes, como YouTube.",
    },
    {
      title: "Derechos de Autor y Licencias",
      description:
        "Este plugin puede permitir acciones (como descargar contenido) que podrían infringir las leyes de derechos de autor o violar acuerdos de licencia si no se usan correctamente. Es crucial respetar los derechos de los creadores de contenido y usar el plugin solo para fines legalmente permitidos.",
    },
    {
      title: "Sin Endoso",
      description:
        "Habilitar este plugin no implica endoso o apoyo por parte de nuestra empresa. El plugin es una entidad separada y no somos responsables de su operación ni de las consecuencias de su uso.",
    },
    {
      title: "Responsabilidad del Usuario",
      description:
        "Eres el único responsable de cualquier acción que realices utilizando este plugin. Esto incluye cualquier consecuencia legal que pueda surgir debido al mal uso o violación de los términos de servicio.",
    },
    {
      title: "Riesgos Potenciales",
      description:
        "Ten en cuenta que el mal uso del plugin podría llevar a la suspensión de la cuenta o acciones legales por parte de las partes afectadas o plataformas.",
    },
    {
      title: "Consentimiento Informado",
      description:
        "Al proceder a habilitar este plugin, reconoces que has leído y entendido estas advertencias y aceptas la plena responsabilidad por el uso del plugin.",
    },
  ],

  "model.auto": "Selecciona automáticamente el mejor modelo.",
  "model.audioshake.transcription":
    "El primer mejor modelo, que implica transcribir y luego alinear, ofrece resultados superiores pero es accesible exclusivamente para usuarios de pago por uso y de prueba (que tarda hasta 10 minutos)",
  "model.audioshake":
    "El segundo mejor modelo se alinea con la letra proporcionada, donde las imprecisiones pueden conducir a resultados subóptimos (toma hasta 10 minutos)",
  "model.wav2vec2":
    "El tercer mejor modelo, se alinea con las letras proporcionadas, donde las imprecisiones pueden conducir a resultados subóptimos, admite casi todos los idiomas (tarda hasta 30 segundos)",
  "model.whisper":
    "El cuarto mejor modelo, que implica transcribir y luego alinear. La letra de salida puede no ser precisa, aunque la sincronización es aceptable (toma hasta 2 minutos)",
  "sync.line.instructions": [
    "Haga clic en el botón Reproducir para reproducir la canción e iniciar el proceso de sincronización",
    "Haga clic en el botón Establecer inicio cuando escuche la primera palabra de la línea actual",
    "Haga clic en el botón Establecer fin después de escuchar la última palabra de la línea actual",
    "Continúa hasta terminar de sincronizar todas las líneas",
  ],
  Undo: "Deshacer",
  Redo: "Rehacer",
  "Set Start": "Establecer Inicio",
  "Set End": "Establecer Fin",
  "dialogs.edit_lyrics.transcription":
    "Cuando se utiliza el modelo de transcripción, el modelo transcribe la canción de forma independiente e identifica la letra por sí solo, sin depender de ninguna letra proporcionada. Luego, tienes la opción de ajustar la letra usando la herramienta de sincronización.",
  "Duet Editor": "Editor de Duetos",
  "Manual Line Sync": "Sincronización Manual de Línea",
  "New Style": "Nuevo Estilo",
  Style: "Estilo",
  Singer: "Cantante",
  "Style Editor": "Editor de Estilo",
  Word: "Palabra",
  Line: "Línea",
  "Split Line": "Dividir Línea",
  "Upgrade to Enable": "Actualiza para Habilitar",
  upgrade_description:
    "Tienes la opción de escuchar o descargar las pistas de karaoke que ya has generado. Sin embargo, si deseas crear pistas de karaoke adicionales, se requiere una actualización.",
  "dialogs.global.no_user.title": "No hay plan activo",
  "dialogs.global.no_user.description":
    "Por favor, actualiza a un plan para continuar.",
  "dialogs.global.no_role.title": "No hay plan activo",
  "dialogs.global.no_role.description":
    "Por favor, actualiza a un plan para continuar.",
  "dialogs.global.blocked_ip.title": "Tu IP está bloqueada",
  "dialogs.global.blocked_ip.description": "Por favor, contacta al soporte.",
  "dialogs.global.rate_limit.title": "Límite de tasa excedido",
  "dialogs.global.rate_limit.description":
    "Puedes cambiar a un plan de Pago Por Uso para acceso ilimitado.",
  "dialogs.global.disk_full.title": "El almacenamiento está lleno",
  "dialogs.global.disk_full.description":
    "Libera espacio para continuar usando Youka.",
  "dialogs.global.too_big.title":
    "El archivo de audio excede el límite de tamaño.",
  "dialogs.global.too_big.description":
    "Tenga en cuenta que el archivo de audio no puede exceder una duración máxima de 15 minutos.",
  Help: "Ayuda",
  Original: "Original",
  Sort: "Ordenar",
  "sort.date.asc": "Fecha de creación (de más antigua a más nueva)",
  "sort.date.desc": "Fecha de creación (de más reciente a más antigua)",
  "sort.title.asc": "Título (A a Z)",
  "sort.title.desc": "Título (Z a A)",
  Start: "Inicio",
  End: "Fin",
  Time: "Tiempo",
  "dialogs.trim.title": "Recortar",
  "dialogs.trim.description":
    "Usa el borde ajustable en la forma de onda para elegir la parte de la canción que deseas conservar.",
  Related: "Relacionado",
  preserve_vocals: "Preservar Voces",
  preserve_vocals_description:
    "Activa esto para preservar las voces como las voces de respaldo.",
  "Separate Audio": "Separar Audio",
  "Separate Model": "Modelo de Separación",
  "Add Lyrics": "Agregar Letras",
  "Background Image or Video": "Imagen de Fondo o Video",
  Docs: "Documentos",
  Watch: "Ver",
  Hide: "Ocultar",
  "watch.sync.title": "¿Cómo arreglar la sincronización de letras fácilmente?",
  "watch.sync.url": "https://www.youtube.com/watch?v=0YdTIYbFeM8",
  Review: "Revisión",
  "watch.review.title": "Reseña de Youka en Trustpilot",
  "Import Subtitles": "Importar Subtítulos",
  Import: "Importar",
  "How to use": "Cómo usar",
  Uppercase: "Mayúsculas",
  "Open Dual Screen": "Abrir Pantalla Doble",
  "Close Dual Screen": "Cerrar Pantalla Doble",
  "Import Karaoke File": "Importar Archivo de Karaoke",
  "dialogs.import_karaoke.title": "Importar Karaoke desde Archivo",
  "dialogs.import_karaoke.description":
    "Importa un archivo karaoke existente, como un MP3/MP4 con letras incorporadas, un archivo LRC con el mismo nombre, o un archivo Karafun.",
  optional: "opcional",
  "Trial Expired": "Prueba Expirada",
  "Subtitles Settings": "Configuración de Subtítulos",
  Milliseconds: "Milisegundos",
  Seconds: "Segundos",
  Text: "Texto",
  Enabled: "Habilitado",
  Duration: "Duración",
  Gap: "Gap",
  Offset: "Desplazamiento",
  "Min Duration": "Duración Mínima",
  "Max Duration": "Duración Máxima",
  "Fade In": "Fade In",
  "Fade Out": "Fade Out",
  "plugins.title.title": "Título de la canción",
  "plugins.title.description":
    "Inserta el título de la canción en el principio del video",
  "plugins.gap_text.title": "Texto de Gap Silencioso",
  "plugins.gap_text.description":
    "Inserta el texto en el gap entre los subtítulos",
  "plugins.gap_progress_bar.title": "Barra de Progreso de Gap Silencioso",
  "plugins.gap_progress_bar.description":
    "Inserta una barra de progreso en el gap entre los subtítulos",
  "plugins.fade.title": "Efecto de Fade",
  "plugins.fade.description":
    "Añade efecto de fade in y fade out a los subtítulos",
  "plugins.offset.title": "Desplazamiento",
  "plugins.offset.description":
    "Desplaza los subtítulos por una cantidad determinada de segundos",
  "plugins.countdown.title": "Cuenta Regresiva de Gap Silencioso",
  "plugins.countdown.description":
    "Inserta una cuenta regresiva en el gap entre los subtítulos",
  Auto: "Automático",
  Subword: "Subpalabra",
  Countdown: "Cuenta Regresiva",
  "Restart required": "Se requiere reiniciar",
  "Reindex Library": "Reindexar Biblioteca",
  "Create playlist": "Crear playlist",
  "Are you sure you want to delete?": "¿Estás seguro de que quieres eliminar?",
  "Add to playlist": "Añadir a la playlist",
  "New playlist": "Nueva playlist",
  "Remove from this playlist": "Eliminar de esta playlist",
  Songs: "Canciones",
  Playlists: "Playlists",
  Name: "Nombre",
  Photo: "Foto",
  "No playlists": "No hay playlists",
  "Welcome to Youka": "Bienvenido a Youka",
  "Search songs online": "Buscar canciones en línea",
  "create.file.title": "Crear Karaoke desde un archivo",
  "create.file.description":
    "Sube tu archivo MP3, MP4 u otros formatos para crear instantáneamente un video de karaoke con letras sincronizadas.",
  "create.online.title": "Crear Karaoke desde canciones en línea",
  "create.online.description":
    "Busca canciones en línea o pega la URL de una canción para crear instantáneamente un video de karaoke con letras sincronizadas.",
  "Change Background": "Cambiar Fondo",
  "Duet Line Split": "Dividir Línea de Dueto",
  Both: "Ambos",
  Custom: "Personalizado",
  Edited: "Editado",
  Trimmed: "Cortado",
  Instrumental: "Instrumental",
  "Add Subword": "Agregar Subpalabra",
  "plugins.max_chars.title": "Máximo de caracteres por línea",
  "plugins.max_chars.description": "Limitar el número de caracteres por línea",
  Limit: "Límite",
  "Background Box": "Caja de Fondo",
  Height: "Altura",
  Width: "Ancho",
  Alpha: "Alfa",
  Color: "Color",
  Duplicate: "Duplicar",
  "Convert to 16x9": "Convertir a 16x9",
  "Resize Video": "Cambiar tamaño del video",
  "Line Alignment": "Alineación de Línea",
  "Shadow Color": "Color de Sombra",
  "Outline Color": "Color de Contorno",
  "Active Color": "Color Activo",
  "Secondary Color": "Color Secundario",
  "Primary Color": "Color Primario",
  "Auto Alignment": "Alineación Automática",
  "Auto Color": "Color Automático",
  "Singer 1": "Cantante 1",
  "Singer 2": "Cantante 2",
  "Top Row": "Fila Superior",
  "Bottom Row": "Fila Inferior",
  "Border Style": "Estilo de Borde",
  "Font Name": "Nombre de la Fuente",
  "Experimental Subtitles Display": "Mostrar Subtítulos Experimentales",
  Position: "Posición",
  "Timing Indicator": "Indicador de Tiempo",
  General: "General",
  Styles: "Estilos",
  Thumbnail: "Miniatura",
  "create.url.title": "Crear Karaoke desde URL",
  "create.url.description": "Crear karaoke desde una URL compatible con yt-dlp",
  "Paste a URL or start typing to search":
    "Pega una URL o empieza a escribir para buscar",
  Top: "Arriba",
  Bottom: "Abajo",
  Center: "Centro",
  "Auto Line Break": "Dividir Línea Automáticamente",
  "Fill Color": "Color de Relleno",
  "Active Line Color": "Color de Línea Activa",
  "Waiting Line Color": "Color de Línea de Espera",
  "Set as Default": "Establecer como Predeterminado",
  Default: "Predeterminado",
  "Make Default": "Hacer predeterminado",
  Image: "Imagen",
  Pause: "Pausar",
  File: "Archivo",
  "Debug Info": "Información de Depuración",
  "File Type": "Tipo de Archivo",
  Language: "Idioma",
  "Reset Settings": "Restablecer Configuración",
  "Failed to start Youka": "Error al iniciar Youka",
  Legacy: "Tradicional",
  Transcription: "Transcripción",
  Alignment: "Alineación",
  Imported: "Importado",
  "With Backing Vocals": "Con Voces de Fondo",
  Stem: "Stem",
  Clear: "Limpiar",
  "Open Directory": "Abrir Directorio",
  "Advanced Settings": "Configuración Avanzada",
  "How to Add a Background Black Box to Subtitles":
    "Cómo añadir un cuadro negro de fondo a los subtítulos",
  "How to Adjust the Line Length": "Cómo ajustar la longitud de la línea",
  "How to Cancel Your Subscription": "Cómo cancelar tu suscripción",
  "How to Center Subtitles": "Cómo centrar los subtítulos",
  "How to Delete a Karaoke": "Cómo eliminar un karaoke",
  "How to Edit the lyrics": "Cómo editar la letra",
  "How to Fix the Sync": "Cómo arreglar la sincronización",
  "How to Keep Choirs": "Cómo mantener los coros",
  "How to Keep the Original Singer’s Voice":
    "Cómo mantener la voz original del cantante",
  "How to Set Up a Duet": "Cómo configurar un dúo",
  "How to Speed Up the Download Process":
    "Cómo acelerar el proceso de descarga",
  "How to Transfer Your Karaoke Library to a New Computer":
    "Cómo transferir tu biblioteca de karaoke a un nuevo ordenador",
  "How to Trim a Karaoke Video": "Cómo recortar un video de karaoke",
  FAQ: "Preguntas Frecuentes",
  "library.description":
    "Accede y administra todas las pistas de karaoke que has creado. Edita, organiza y perfecciona tus proyectos.",
  "How to Change the Background Video": "Cómo cambiar el video de fondo",
  "Auto Size": "Tamaño Automático",
  "dialogs.global.no_credits.title": "No hay créditos disponibles",
  "dialogs.global.no_credits.description":
    "Por favor, recarga créditos para continuar",
  "Credits are over! Click to buy more":
    "¡Se han agotado los créditos! Haz clic para comprar más",
  "How to Add a Line Break": "Cómo añadir un salto de línea",
  "dialogs.global.no_user.many_emails_description":
    "El acceso ha sido bloqueado debido a múltiples inicios de sesión con diferentes direcciones de correo electrónico. Por favor, compra una suscripción para continuar.",
  "dialogs.global.no_user.virtual_machine_description":
    "El acceso ha sido bloqueado porque estás utilizando una máquina virtual. Para acceder a la prueba gratuita, instala Youka en un sistema operativo estándar. Si tienes una suscripción, renuévala para recuperar el acceso. Si no necesitas generar karaoke de forma continua, puedes optar por un plan de pago por uso, asegurándote de que solo pagues cuando crees contenido nuevo de karaoke.",
  "Import Stem": "Importar Stem",
  "Active Outline Color": "Color de Contorno Activo",
  "Inactive Outline Color": "Color de Contorno Inactivo",
  "Inactive Line Color": "Color de Línea Inactiva",
  "Active Line": "Línea Activa",
  "Inactive Line": "Línea Inactiva",
  "End Extra": "Extra al final",
  Expand: "Expandir",
  Collapse: "Contraer",
  "Copy Line": "Copiar línea",
  "Copy Word": "Copiar palabra",
  "Cut Line": "Cortar línea",
  "Cut Word": "Cortar palabra",
  "Delete Line": "Eliminar línea",
  "Delete Subword": "Eliminar subpalabra",
  "Delete Word": "Eliminar palabra",
  "Add Line": "Agregar línea",
  "Add Word": "Agregar palabra",
  "Paste Line": "Pegar línea",
  "Paste Word": "Pegar palabra",
  "Paste Subword": "Pegar subpalabra",
  "Play Line": "Reproducir línea",
  "Play Word": "Reproducir palabra",
  "Select Line": "Seleccionar línea",
  "Manual Sync": "Sincronización manual",
  "Trim Start": "Recortar inicio",
  "Trim End": "Recortar fin",
  "Creating will use 1 credit": "Crear usará 1 crédito",
  All: "Todos",
  "Number of Singers": "Número de cantantes",
  "Style Mapping": "Mapeo de estilos",
  "Associate subtitle styles with singers":
    "Asociar estilos de subtítulos con cantantes",
  "Upper first line": "Primera línea superior",
  "Upper second line": "Segunda línea superior",
  "Lower first line": "Primera línea inferior",
  "Lower second line": "Segunda línea inferior",
  Lock: "Bloquear",
  "2 Lines": "2 líneas",
  "4 Lines": "4 líneas",
  Static: "Estático",
  Dynamic: "Dinámico",
  "Subtitles Type": "Tipo de subtítulos",
  "Danger Zone": "Zona peligrosa",
  Copy: "Copiar",
  Copied: "Copiado",
  "Copy Settings": "Copiar Configuración",
  "cta.social.title": "¡Obtén 50 créditos GRATIS!",
  "cta.social.description":
    "Comparte una publicación sobre Youka en las redes sociales, etiquétanos y gana 50 créditos gratis por plataforma.",
  "cta.social.description.2":
    "Haz clic para visitar la página de Facebook de Youka, dale me gusta, comparte una publicación y envía tu correo electrónico en el chat para recibir 50 créditos gratis.",
  "Merge Line": "Unir línea",
  Player: "Reproductor",
  "Key Step": "Paso de tono",
  "Tempo Step": "Paso de tempo",
  "Shift Line Forward": "Desplazar línea hacia adelante",
  "Shift Line Backward": "Desplazar línea hacia atrás",
  "create.description":
    "Crea karaoke a partir de archivos de audio o video (MP3, MP4 y más), o pega una URL para generar instantáneamente un video de karaoke con letras sincronizadas.",
  "No file chosen": "No hay archivo seleccionado",
  "Choose File": "Seleccionar archivo",
  "Watch Quick Start Video": "Ver video de inicio rápido",
  "Export Settings": "Exportar configuración",
  "Import Settings": "Importar configuración",
  "Video Guides": "Guías de video",
  "Quick Start Guide": "Guía de inicio rápido",
  "Lyrics Sync Guide": "Guía de sincronización de letras",
  Resolution: "Resolución",
  "Subtitles Preset": "Ajuste preestablecido de subtítulos",
  Preset: "Preajuste",
  Done: "Hecho",
  "New Style Mapping": "Nueva asignación de estilo",
  Horizontal: "Horizontal",
  Vertical: "Vertical",
  Square: "Cuadrado",
  New: "Nuevo",
  "New Subtitles Preset": "Nuevo ajuste preestablecido de subtítulos",
  "Change Aspect Ratio": "Cambiar relación de aspecto",
  "copyright.title.a": "Acepto la",
  "copyright.title.b": "Confirmación de uso de música",
  "copyright.description":
    "Al marcar esta casilla, confirmas que (A) posees todos los derechos de la música incluida en este video; o (B) la música es de dominio público; o (C) tienes permiso de todos los titulares de derechos necesarios para usar la música en la plataforma Youka.",
  "Add Intro Video": "Añadir vídeo de introducción",
  "dialogs.intro.description":
    "Añade un vídeo personalizado al comienzo del karaoke",
  Transition: "Transición",
  Fade: "Desvanecer",
  "Circle Open": "Círculo abierto",
  "Circle Close": "Círculo cerrado",
  "Diagonal Open": "Apertura diagonal",
  "Diagonal Close": "Cierre diagonal",
  "Smooth Left": "Suavizar izquierda",
  "Smooth Right": "Suavizar derecha",
  Squares: "Cuadrados",
  Dissolve: "Disolver",
  Type: "Tipo",
  "Song Title": "Título de la canción",
  Artists: "Cantantes",
  Artist: "Cantante",
  "Parse Titles": "Analizar títulos",
  "sort.artist.asc": "Cantante (A a Z)",
  "sort.artist.desc": "Cantante (Z a A)",
  "Title Style": "Estilo de título",
  "Artist Style": "Estilo de cantante",
  "Analyse Library": "Analizar biblioteca",
  "No Filter": "Sin filtro",
  "credits.message_one": "Esto usará {{count}} crédito",
  "credits.message_other": "Esto usará {{count}} créditos",
  "credits.badge_one": "{{count}} crédito",
  "credits.badge_other": "{{count}} créditos",
  "Provide song lyrics to save credits":
    "Proporciona letras de canciones para ahorrar créditos",
  "Upload to Cloud Library": "Subir a la biblioteca en la nube",
  "Cloud Library": "Biblioteca en la nube",
  "Open Cloud Library": "Abrir biblioteca en la nube",
};
